import { useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { getCountrySentenceI18nKey } from 'marketplace-ui-common/utils/i18n';
import useInstallStats from 'marketplace-ui-apps-core/details/hooks/useInstallStats';
import { useAppContext } from '../../context/AppContext';
const THRESHOLD = 50;
const translateAttributeValue = ({
  attributeType,
  attributeValue
}) => {
  switch (attributeType) {
    case 'country':
      return unescapedText(getCountrySentenceI18nKey(attributeValue));
    case 'industry':
      return unescapedText(`marketplace-ui-common.industry.${attributeValue}.sentence`);
    case 'plan':
      return unescapedText(`marketplace-ui-common.groupTags.tier.${attributeValue}`);
    default:
      return '';
  }
};
function getHighestRelevantValueFromObject({
  object,
  type
}) {
  const highestKey = Object.keys(object).reduce((currHighestKey, currKey) => object[currKey] >= (object[currHighestKey] || THRESHOLD) ? currKey : currHighestKey, null);
  return highestKey ? {
    [translateAttributeValue({
      attributeType: type,
      attributeValue: highestKey
    })]: object[highestKey]
  } : null;
}
export function useAppPersonalizationInstallStats(offeringId) {
  const appContext = useAppContext();
  const {
    installStatsData,
    installStatsLoading
  } = useInstallStats({
    offeringId: offeringId.toString(),
    skip: appContext !== 'app'
  });
  const installStats = installStatsData === null || installStatsData === void 0 ? void 0 : installStatsData.installStats;
  return useMemo(() => {
    if (!installStats) {
      return {
        country: null,
        industry: null,
        plan: null,
        installStatsLoading
      };
    }
    const {
      countryStats,
      industryStats,
      productPlanStats
    } = installStats;

    // We don't currently have translations for MARKETING_BASIC or CMS_PROFESSIONAL
    // this is temporary until we sort out the plan enums
    // https://hubspot.slack.com/archives/CP3UK8J9X/p1717770273789009
    const filteredProductPlanStats = Object.keys(productPlanStats).filter(objKey => objKey !== 'MARKETING_BASIC' && objKey !== 'CMS_PROFESSIONAL').reduce((newObj, key) => {
      newObj[key] = productPlanStats[key];
      return newObj;
    }, {});
    const country = getHighestRelevantValueFromObject({
      object: countryStats,
      type: 'country'
    });
    const industry = getHighestRelevantValueFromObject({
      object: industryStats,
      type: 'industry'
    });
    const plan = getHighestRelevantValueFromObject({
      object: filteredProductPlanStats,
      type: 'plan'
    });
    return {
      country,
      industry,
      plan,
      installStatsLoading
    };
  }, [installStats, installStatsLoading]);
}